type Gtag = (...args: unknown[]) => void;

document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const link = target.closest<HTMLAnchorElement>('[data-track-event]');
  if (!link) return;

  const gtag = (window as { gtag?: Gtag }).gtag;
  gtag?.('event', link.dataset.trackEvent, {
    page: link.dataset.trackPage,
    position: link.dataset.trackPosition,
  });
});


// All answers remain expanded without JavaScript. With JS, keep a compact page
// and open the exact answer addressed by a shared link or browser history.
const answers = [...document.querySelectorAll<HTMLDetailsElement>('[data-help-answer]')];
const openLinkedAnswer = () => {
  let id = '';
  try {
    id = decodeURIComponent(window.location.hash.slice(1));
  } catch {
    return;
  }
  const article = document.getElementById(id);
  const answer = article?.querySelector<HTMLDetailsElement>('[data-help-answer]');
  if (!answer) return;
  answer.open = true;
  article?.scrollIntoView({ block: 'start' });
};
answers.forEach((answer, index) => { answer.open = index === 0; });
openLinkedAnswer();
window.addEventListener('hashchange', openLinkedAnswer);
